import { Tooltip } from "@material-ui/core";
import React, { useRef } from "react";
import {
  InputFile,
  ButtonFile,
  UpLoadFileContainer,
  NameFile,
  ButtonDelete,
} from "./UploadImage.styled";

const UploadImage = ({
  displayNameButton,
  nameFile,
  setFile,
  withStyle = true,
}) => {
  const file = useRef();
  let handleFile = (e) => {
    let files = e.target.files;

    if (
      files &&
      !files[0]?.name.match(/\.(jpg|png|jpeg|gif|JPG|PNG|JPEG|GIF)$/)
    ) {
      alert("Please select a valid image format (GIF,PNG,JPG or JPEG)");
      return false;
    }

    let urlPreviewImage = URL.createObjectURL(e.target.files[0]);
    setFile("imagenFile", files, urlPreviewImage);
  };

  let handleDeleteFile = () => {
    file.current.value = null;
    setFile("imagenFile", null, "#");
  };

  return (
    <UpLoadFileContainer withStyle={withStyle}>
      <Tooltip title="JPG,PNG,JPEG,GIF">
        <ButtonFile>
          <InputFile ref={file} type="file" onChange={handleFile}></InputFile>
          {displayNameButton}
        </ButtonFile>
      </Tooltip>
      {/* <span>JPG PNG JPEG</span> */}
      {nameFile ? (
        <NameFile>
          {nameFile}{" "}
          <ButtonDelete type="button" onClick={handleDeleteFile}>
            {" "}
            x{" "}
          </ButtonDelete>{" "}
        </NameFile>
      ) : null}
    </UpLoadFileContainer>
  );
};

export default UploadImage;
